import { QuestionsService, QuestionTopicsService } from "@/common/api.service"
import { FETCH_QUESTION, FETCH_INDIVIDUAL_QUESTION, ADD_QUESTION, UPDATE_QUESTION, DELETE_QUESTION, FETCH_QUESTION_TOPIC, ADD_QUESTION_TOPIC_DATA, RESET_STATE} from "./actions.type"
import { SET_QUESTION, SET_INDIVIDUAL_QUESTION, SET_ERROR_QUESTION, SET_QUESTION_TOPIC, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        questions: [],
        individualquestion: [],
        questionerrors: null,
        questiontopicdata: [],
    }
}

let state = initialState()

const getters = {
    questions(state) {
        return state.questions
    },
    individualquestion(state) {
        return state.individualquestion
    },
    questiontopicdata(state) {
        return state.questiontopicdata
    }
}

const actions = {
    async [FETCH_QUESTION](context, slug) {
        const { data } = await QuestionsService.get(slug)
        context.commit(SET_QUESTION, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_QUESTION](context, slug) {
        const { data } = await QuestionsService.get(slug)
        context.commit(SET_INDIVIDUAL_QUESTION, data.data)
        return data;
    },  
    async [ADD_QUESTION](context, payload) {
        return await QuestionsService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUESTION, error.response.data.errors)
        });
    },     
    async [UPDATE_QUESTION](context, payload) {
        // return await QuestionsService.update(payload, payload.get('question_id'))
        return await QuestionsService.update(payload, payload.question_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUESTION, error.response.data.errors)
        });
    },  
    async [DELETE_QUESTION] (context, id) {
        return await QuestionsService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUESTION, error.response.data.errors)
        });
    },  
    async [FETCH_QUESTION_TOPIC](context, slug) {
        const { data } = await QuestionTopicsService.get(slug)
        context.commit(SET_QUESTION_TOPIC, data.data)
        return data;
    }, 
    async [ADD_QUESTION_TOPIC_DATA](context, payload) {
        return await QuestionTopicsService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_QUESTION, error.response.data.errors)
        });
    },   
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_QUESTION](state, error) {
        state.questionerrors = error
    },      
    [SET_QUESTION](state, questionsdata) {
        state.questions = questionsdata
    },
    [SET_INDIVIDUAL_QUESTION](state, individualquestion) {
        state.individualquestion = individualquestion
    }, 
    [SET_QUESTION_TOPIC](state, questiontopicdata) {
        state.questiontopicdata = questiontopicdata
    },   
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};